import gql from 'graphql-tag';
import { articleFragments } from '../fragments';

const articleQueries = {
  ArticleById: (id) => {
    return gql`
      query {
        articleById (
          id: ${id}
        ) {
          ...FullArticle
        }
      }
      ${articleFragments.fullArticle}
    `;
  },
  LatestArticleOrByPublicId: gql`
    query (
      $id: String,
      $subscriptionId: Int,
      $memberful: Boolean
    ) {
      latestArticleOrByPublicId (
        publicId: $id,
        subscriptionId: $subscriptionId,
        memberful: $memberful
      ) {
        ...FullArticle
      }
    }
    ${articleFragments.fullArticle}
  `,
  ArticlesByUserAndSubscriptionId: gql`
    query ($subscriptionId: Int!, $input: ArticleFeedInput!) {
      articlesByUserAndSubscriptionId (subscriptionId: $subscriptionId, input: $input) {
        count
        articles {
          ...PartialArticle
        }
      }
    }
    ${articleFragments.partialArticle}
  `,
  ArticlesByMonthAndSubscription: gql`
    query ($subscriptionId: Int!, $year: Int!, $month: Int!) {
      articlesByMonthAndSubscription (subscriptionId: $subscriptionId, year: $year, month: $month) {
        ...PartialArticle
      }
    }
    ${articleFragments.partialArticle}
  `,
  SubscriptionFirstArticleDate: gql`
    query ($subscriptionId: Int!) {
      subscriptionFirstArticleDate (subscriptionId: $subscriptionId)
    }
  `,
  ArticleSearchAdmin: (options) => {
    return gql`
      query {
        articleSearchAdmin (
          subscriptionId: ${options.subscriptionId}
          input: {
            searchTerm: "${options.searchTerm}"
            limit: ${options.limit}
            offset: ${options.offset}
            orderBy: "${options.orderBy}"
            orderByDirection: "${options.orderByDirection}"
          }
        ) {
          count
          articles {
            ...PartialArticle
          }
        }
      }
      ${articleFragments.partialArticle}
    `;
  },
  ArticleRecipientsAdmin: (articleId) => {
    return gql`
      query {
        articleRecipientsAdmin (
          articleId: ${articleId}
        ) {
          count
          recipients {
            email
            firstName
            lastName
            sentAt
          }
        }
      }
    `;
  }
};

export default articleQueries;
